// NEW - PIK202006-147 - 210124 - Newsletter Subscription Modal

'use strict';

var newsletterModal = '.newsletterModal';
var formValidation = require('base/components/formValidation');

function redirectVP() {
    var rawData = $('#newsletterModal .params').data('params');
    var data = typeof rawData === 'string' ? JSON.parse(rawData) : rawData || {};
    if (data.param && data.param.key && data.param.value) {
        var key = data.param.key;
        var value = data.param.value;
        var url = new URL(window.location.href);
        url.searchParams.set(key, value);
        window.location.href = url.toString();
    }
}

function reloadParams() {
    $('body').on('click', '#newsletterModalCloseButton, .modal-backdrop.show', function () {
        redirectVP();
    });
}

function isGenderPreferenceSelected() {
    return $('#genderMethod-woman').prop('checked') || $('#genderMethod-man').prop('checked') || $('#genderMethod-both').prop('checked');
}

function openModalContent() {
    $(newsletterModal).css('display', 'block');
    $('<div class="modal-backdrop fade show"></div>').appendTo(document.body);
    $('body').addClass('modal-open');

    $('body').on('click', '.modal-backdrop.show', function (e) {
        e.preventDefault();
        $(newsletterModal).css('display', 'none');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        $('body').off('click', '.modal-backdrop.show');
    });
}

module.exports = function () {
    $('body').on('click', '#newsletterModalCloseButton', function (e) {
        e.preventDefault();
        $(newsletterModal).css('display', 'none');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        $('body').off('click', '.modal-backdrop.show');
        $('.floating-popup').removeClass('d-none');
    });

    $('body').on('click', '.newsletter-open-modal', function (e) {
        e.preventDefault();
        openModalContent();
        $('.floating-popup').addClass('d-none');
    });

    $('#sf-button').on('click', function () {
        $('#registration-form-email').val('');
        $('label[for="registration-form-email"]').removeClass('no-empty');
        var email = $('#sf-email').val();
        if (email && email.length > 0) {
            $('label[for="registration-form-email"]').addClass('no-empty');
            $('#registration-form-email').val(email);
            $('#registration-form-email').focus();
            /* eslint-disable no-undef */
            dataLayer.push({
                event     : 'Suscripción Newsletter Footer',
                Categoria : 'Suscripción Newsletter Footer',
                Accion    : 'Apertura de pop up con email de cliente',
                Etiqueta  : window.location.href
            });
        } else {
            /* eslint-disable no-undef */
            dataLayer.push({
                event     : 'Suscripción Newsletter Footer',
                Categoria : 'Suscripción Newsletter Footer',
                Accion    : 'Apertura de pop up sin email de cliente',
                Etiqueta  : window.location.href
            });
        }
        var locale = window.CQuotient.locale;
        var originUrl = window.location.origin;
        var destinyUrl = '/unete.html';
        var fullUrl = originUrl + destinyUrl;
        if (locale === 'en_US' || locale === 'es_US') {
            sessionStorage.setItem('emailValue', email);
            window.location.href = fullUrl;
        } else {
            $('.newsletter-open-modal').trigger('click');
        }
    });

    $('#sf-email').on('keypress', function (event) {
        if (event.which === 13) {
            $('#sf-button').trigger('click');
        }
    });

    $('.floating-popup #closeIconContainer').on('click', function () {
        $('.floating-popup').addClass('d-none');
        var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)joinToNewslettersFromPopUp\s*=\s*([^;]*).*$)|^.*$/, '$1');

        var deleteCookie = function (name) {
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        };
        var setCookie = function (name, value, days) {
            var expires = '';
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = '; expires=' + date.toUTCString();
            }
            document.cookie = name + '=' + (value || '') + expires + '; path=/;secure=falseSameSite=None';
        };
        cookieValue = '3';
        var cookiePopup = 'joinToNewslettersFromPopUp';
        var cookieDuration = 365;
        deleteCookie(cookiePopup);
        setCookie(cookiePopup, cookieValue, cookieDuration);
    });

    $('.floating-popup #bubbleWrapper').on('click', function (e) {
        e.preventDefault();
        openModalContent();
        $('.floating-popup').addClass('d-none');
    });

    $('body').on('click', '.newsletterSubscriptionButton', function () {
        var rgpdSelected = $('#rgpdTerms').prop('checked');
        if (rgpdSelected) {
            $('#registerNewsletterPopUpForm #rgpdTerms').removeClass('is-invalid');
        } else {
            $('#registerNewsletterPopUpForm #rgpdTerms').addClass('is-invalid');
        }
        if (!isGenderPreferenceSelected()) {
            $('#registerNewsletterPopUpForm .genderRadioButtons').addClass('is-invalid');
            $('#registerNewsletterPopUpForm .gender-preferences-error').addClass('d-block');
        } else {
            $('#registerNewsletterPopUpForm .genderRadioButtons').removeClass('is-invalid');
            $('#registerNewsletterPopUpForm .gender-preferences-error').removeClass('d-block');
        }
    });

    $('#newsletterModal form.newsletter-registration').submit(function (e) {
        e.preventDefault();

        var rgpdSelected = $('#rgpdTerms').prop('checked');
        if (!rgpdSelected) {
            $('#rgpdTerms').addClass('is-invalid');
            return false;
        }
        $('#rgpdTerms').removeClass('is-invalid');


        if (isGenderPreferenceSelected()) {
            var form = $(this);
            var url = form.attr('action');

            $('.newsletterSubscriptionButton').prop('disabled', true);
            $('.btn-text').hide();
            $('.loadingSpinner').show();

            $.ajax({
                url      : url,
                type     : 'post',
                dataType : 'json',
                data     : form.serialize(),
                success  : function (responseData) {
                    $('.newsletterSubscriptionButton').prop('disabled', false);
                    $('.btn-text').show();
                    $('.loadingSpinner').hide();

                    if (!responseData.success) {
                        if (responseData.existingCustomer) {
                            $('#already-subscribed-message').removeClass('d-none');
                            $('#email-exists-message').removeClass('d-none');
                        } else if (responseData.invalidEmail) {
                            $('#error-email-message').removeClass('d-none');
                        } else {
                            formValidation(form, responseData);
                        }
                    } else {
                        $('#already-subscribed-message').addClass('d-none');
                        $('#email-exists-message').addClass('d-none');
                        $('#registration-form-email').removeClass('is-invalid');
                        $('.newsletter-header-container').addClass('d-none');
                        $('.newsletterModal-step1').addClass('d-none');
                        $('.newsletterModal-step2').removeClass('d-none');
                        $('.modal-body-newsletter').eq(0).addClass('no-margin-top');

                        var emailValue = $('#registration-form-email').val();
                        $('#hidden-email-input').val(emailValue);

                        var pageType = '';
                        dataLayer.forEach(function (evento) {
                            if (evento.event === 'pagina') pageType = evento.pageType;
                        });

                        var etiqueta = pageType + '-' + window.location.href;
                        dataLayer.push({
                            event     : 'Suscripción Newsletter',
                            Categoría : 'Suscripción Newsletter',
                            Acción    : 'Suscripción Enviada',
                            Etiqueta  : etiqueta
                        });
                        if (responseData.hasOwnProperty('dataLayer')) {
                            dataLayer.push(responseData.dataLayer);
                        }
                        reloadParams();
                    }
                },
                error: function (err) {
                    console.error(err);
                }
            });
        }
        return false;
    });

    $('#registration-form-email').on('input', function () {
        $('#already-subscribed-message').addClass('d-none');
        $('#email-exists-message').addClass('d-none');
        $(this).removeClass('is-invalid');
    });

    $('body').on('click', '.newsletter-open-modal', function () {
        $('#already-subscribed-message').addClass('d-none');
        $('.form-row, .form-group, .btn_primary, .form-control-label').removeClass('d-none');
        $('button[type="submit"]').removeClass('d-none');
        $('#registration-form-email').css('border-color', '');
    });

    $('body').off('click', '#newsletterModal .icon.copiarcupon').on('click', '#newsletterModal .icon.copiarcupon', function () {
        var couponCode = $(this).closest('.discount-container').find('.coupon-code').text().trim();

        var textArea = document.createElement('textarea');
        textArea.value = couponCode;
        document.body.appendChild(textArea);

        textArea.select();
        document.execCommand('copy');

        document.body.removeChild(textArea);
    });

    $('body').on('input change', '#newsletterModal #birthdate', function () {
        if ($(this).val()) {
            $('.continue-button').css('display', 'none');
            $('.confirm-button').prop('disabled', false);
        } else {
            $('.confirm-button').prop('disabled', true);
        }
    });

    $(document).ready(function () {
        setTimeout(function () {
            if ($('#newsletterModal #birthdate').val()) {
                $('.confirm-button').prop('disabled', false);
            }
        }, 500);
    });

    $(document).on('submit', '#newsletterModal #birthdayForm', function (e) {
        if (!this.checkValidity()) {
            return;
        }
        e.preventDefault();
        var form = $(this);
        var url = form.attr('action');

        $.ajax({
            url      : url,
            type     : 'post',
            dataType : 'json',
            data     : form.serialize(),
            success  : function (data) {
                console.log('Éxito:', data);
                $('.newsletter-header-container').addClass('d-none');
                $('.birthday-section').hide();
                $('.birthday-confirmation-section').removeClass('birthday-section-hidden');
            },
            error: function (xhr) {
                console.error('Error:', xhr.status, xhr.responseText);
                $('.birthday-section').hide();
                $('.birthday-confirmation-section').removeClass('birthday-section-hidden');
            }
        });

        return false;
    });

    $('body').on('click', '#newsletterModal .confirm-button', function (e) {
        if (!$(this).prop('disabled')) {
            e.preventDefault();
            $('#birthdayForm').submit();
        }
    });
    $('body').on('click', '#newsletterModal .continue-button, #newsletterModal .popup-alert-email-buy', function (e) {
        e.preventDefault();
        $(newsletterModal).css('display', 'none');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        redirectVP();
    });
};
